export const MEMBER_REGISTRATION_CONTROLLER_ID = 'MemberRegistration';
export const LOAN_CALCULATOR_CONTROLLER_ID = 'LoanCalculator';
export const CARD_SLIDER_CONTROLLER_ID = 'CardSlider';
export const INTRO_SLIDER_CONTROLLER_ID = 'IntroSlider';
export const INTRO_VIDEO_CONTROLLER_ID = 'IntroVideo';
